export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11158.a0adb842.jpg";